<template>
  <div class="v_box">
    <div class="b_banxin1">
      <div class="flex v_boxin">
        <div class="v_boxson1" v-for="(item,index) in leftnav" :key="index">
          <div class="v_boxsontop txtnowarp">
						    {{item.fastname}}                         
          </div>
          <div class="v_boxlist txtnowarp" v-for="(items,indexs) in item.childrens" :key="indexs" @click="tohelp(item.tabkeys,items.tabkeys,items.id)">
            {{items.lastname}}
          </div>
        </div>
        <div class="v_boxson2" :style="{backgroundImage:'url('+bgim+')'}">
         <div class="v_boxsontop txtnowarp">
           自营覆盖区县
         </div>
         <div class="v_boxson2btn txtnowarp4">
           已向全省100个区县提供自营配送服务，<br>支持货到付款、POS机刷卡和售<br>
           后上门服务。
         </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import qs from 'qs'
export default {
  data() {
    return {
      bgim: require("@/assets/img/quanguoditu.png"),
      leftnav: []
    };
  },
   mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getfooter()
  },
  methods: {
    tohelp(ulid, liid,helpid) {
      let that = this;
      that.$router.push({
        path: "/helplist",
        query: { ulid: ulid, liid: liid,helpid:helpid}
      });
    },
    getfooter() {
      let that = this;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.gethelplist,
      })
        .then(function(response) {
          let data = response.data;
          if (data.stateCode == 10000) {
                that.leftnav=data.data
          } else {
            that.$message({
              message: data.msg,
              type: "warning"
            });
          }
        })
        .catch(function(error) {});
      // gethelplist
    }
  }
};
</script>
<style scoped>
.v_box {
  background-color: #d81023;
  width: 100%;
  box-sizing: border-box;
  padding: 20px 0;
}

.v_boxin {
  width: 100%;
  border-left: 1px solid #e0404f;
  border-right: 1px solid #e0404f;
}

.v_boxson1 {
  flex: 1;
  border-right: 1px solid #e0404f;
}

.v_boxson2 {
  flex: 2;
  border-left: 1px solid #e0404f;
  background-repeat: no-repeat;
  background-position: center 10px;
  height: 200px;
  box-sizing: border-box;
}

.v_boxsontop {
  width: 100%;
  line-height: 40px;
  font-size: 20px;
  color: #ffffff;
  height: 40px;
  text-align: center;
}

.v_boxlist {
  display: block;
  width: 100%;
  line-height: 40px;
  color: #ffffff;
  height: 40px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}

.v_boxson2btn {
  height: 160px;
  line-height: 40px;
  font-size: 16px;
  padding: 0 40px;
  box-sizing: border-box;
  color: #ffffff;
}
</style>